import React, { Component } from "react";
import getContract, {
  getTotalContractTransactions
} from "../../services/contract";
import getTokenContract from "../../services/tokenContract";
import { ethers } from "ethers";
import levelPrices from "../../services/levelPrice";
import getWallet from "../../services/wallet";
import Slot from "./tree/slot";
import { TransactionService } from "../../services/transactionService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import withWrapper from "../../helpers/withWrapper";
import ImageZoom from "./ImageZoom";
import { getLastActivities } from "../../services/activities";
import {
  AiOutlineUsergroupAdd,
  AiFillAccountBook,
  AiFillCopy,
  AiOutlinePaperClip,
  AiOutlineShareAlt,
  AiOutlineApartment,
} from "react-icons/ai";
// import "./layout.css";



class Dashboard extends Component {
  state = {
    userAddress: "",
    isWalletConnected: false,
    isAuthorized: false,
    levelBought: 0,
    reinvestCounts: new Array(4).fill(0),
    dataLoaded: false,
    origRef: 0,
    partners: 0,
    userId: 0,
    activities: [],
    contractAddress: "",
    totalTxn: 0,
    totalInvested: 0,
    userIncomeAutoRun: 0,
    userTotalIncome: 0,
    refIncome: 0,
    userTotalIncomeIp: 0,
    isUserRegisteredInAutoRun: false,
  };

  notify = (message) => toast(message);

  

  constructor(props) {
    super(props);
    const totalLevels = 4;
    const treeNodes = 15;
    let idsArray = new Array(totalLevels)
      .fill(0)
      .map(() => new Array(treeNodes).fill(0));
    this.state.idsWithLevels = idsArray;
    if (props.router.params.id) {
      this.state.userId = props.router.params.id;
    } else {
      this.state.userId = 1;
    }
    this.props.onSetUserId(this.state.userId);
  }
    state = {
    matrixScale: 1
  };

  goHome = () => {
    this.props.router.navigate("/");
  };

updateMatrixScale = () => {
  if (typeof window === "undefined") return;

  const screenWidth = window.innerWidth;
  const MATRIX_WIDTH = 1100;

  let scale;

  // 📱 MOBILE → enlarge
  if (screenWidth <= 480) {
    scale = screenWidth / 420;
  }
  // 📱 small phone
  else if (screenWidth <= 768) {
    scale = screenWidth / 700;
  }
  // 💻 desktop
  else {
    scale = screenWidth / MATRIX_WIDTH;
  }

  // ✅ allow enlarge
  scale = Math.min(Math.max(scale, 0.9), 2);

  this.setState({ matrixScale: scale });
};


async componentDidMount() {
  await this.init();

  this.updateMatrixScale();

  window.addEventListener("resize", this.updateMatrixScale);
}

componentWillUnmount() {
  window.removeEventListener("resize", this.updateMatrixScale);
}

getMobileScale = () => {
  if (typeof window === "undefined") return 1;

  const screenWidth = window.innerWidth;

  const MATRIX_WIDTH = 1100;

  // scale to FULL WIDTH
  const scale = screenWidth / MATRIX_WIDTH;

  // mobile enlarge protection
  return Math.min(Math.max(scale, 0.75), 1);
};

  getActivitiesData = async () => {
    const activities = await getLastActivities(10);
    this.setState({ activities });
  };

  initializeState = async (connectedWalletAddress) => {
    const contract = await getContract();
    
    let userId = this.state.userId;

    const totalMembers = ethers.BigNumber.from(
      await contract.lastIDCount()
    ).toNumber();
    if (totalMembers < userId) {
      alert(`User with id ${userId} not found`);
      userId = 1;
    }

    const userAddress = await contract.getAddressById(userId);
    
    const totalValueInvested = ethers.BigNumber.from(
      await contract.totalValueInvested()
    ).toString();

    const userInfoResponse = await contract.userInfos(userId);

    const levelBought = ethers.BigNumber.from(
      userInfoResponse["levelBought"]
    ).toNumber();

    console.log("levelBought: ", levelBought);
    

    let refIncome = parseFloat(
      ethers.utils.formatUnits(userInfoResponse["refIncome"])
    ).toFixed(2);

    let userTotalIncome = parseFloat(
      ethers.utils.formatUnits(userInfoResponse["totalIncome"])
    ).toFixed(2);

    let userTotalIncomeIp = parseFloat(
      ethers.utils.formatUnits(userInfoResponse["totalIpIncome"])
    );

    const multiPayoutEarning = parseFloat(
      ethers.utils.formatUnits(userInfoResponse["multiPayoutEarning"])
    ).toFixed(2);

    const origRef = ethers.BigNumber.from(
      userInfoResponse["origRef"]
    ).toNumber();
    const partners = ethers.BigNumber.from(
      userInfoResponse["partners"]
    ).toNumber();

    const reinvestCountsResponse = await contract.getRecycles(userId);
    const reinvestCounts = reinvestCountsResponse.map((c) =>
      ethers.BigNumber.from(c).toNumber()
    );

    const valueInvestedBN = await contract.totalValueInvested();
    const totalInvested = +ethers.utils.formatUnits(valueInvestedBN);

    let userWithLevels = this.state.idsWithLevels;
    try {
      const ids = await contract.getAllSlotTrees(userId);
      for (let i = 0; i < 5; i++) {
        ids[i].forEach((response, index) => {
          const id = ethers.BigNumber.from(response).toNumber();
          userWithLevels[i][index] = id;
        });
      }
    } catch (error) {
      console.log(error.message);
    }

    if (
  connectedWalletAddress &&
  userAddress &&
  connectedWalletAddress.toLowerCase() === userAddress.toLowerCase()
) {
      this.setState({ isAuthorized: true });
    }

    this.setState({
      // userIncomeAutoRun,
      userId,
      userAddress,
      userTotalIncome,    
      totalMembers,
      refIncome,
      totalValueInvested,
      origRef,
      partners,
      isUserRegisteredInAutoRun: false,
      levelBought,
      totalInvested,
      reinvestCounts,
      multiPayoutEarning,
      idsWithLevels: userWithLevels,
      dataLoaded: true,
      contractAddress: contract.address
    });
  };

  async componentDidMount() {
    await this.init();
  }

  async init() {
    const wallet = await getWallet();
    const connectedWallet = await wallet.signer?.getAddress();
    if (!wallet.isReadOnly) {
      this.setState({ isWalletConnected: true });
      // if(id1Wallets.some(wallet => wallet.toLowerCase() == connectedWallet.toLowerCase())) {
      //     this.setState({isId1WalletConnected: true});
      // }
    }

    // const count = await getTotalContractTransactions();
    // this.setState({ totalTxn: count });

    const promise = this.initializeState(connectedWallet);

    await toast.promise(promise, {
      pending: "Fetching data ...",
      success: "Ready to view!",
      error: "Error fetching data",
    });
  }

  handleCopy = () => {
    if (navigator.clipboard) {
      var textarea = document.createElement("textarea");
      textarea.textContent = this.state.userAddress;
      textarea.style.position = "fixed";
      textarea.style.width = "2em";
      textarea.style.height = "2em";
      textarea.style.padding = 0;
      textarea.style.border = "none";
      textarea.style.outline = "none";
      textarea.style.boxShadow = "none";
      textarea.style.background = "transparent";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.notify("Copied to clipboard");
      } catch (e) {
        document.body.removeChild(textarea);
      }
      // this.notify("Copying not supported in this dapp browser");
    } else {
      navigator.clipboard
        .writeText(this.state.userAddress)
        .then(() => {
          this.notify("Copied to clipboard");
        })
        .catch((err) => {
          this.notify(err);
        });
    }
  };

  handleCopyContract = () => {
    if (navigator.clipboard) {
      var textarea = document.createElement("textarea");
      textarea.textContent = this.state.contractAddress;
      textarea.style.position = "fixed";
      textarea.style.width = "2em";
      textarea.style.height = "2em";
      textarea.style.padding = 0;
      textarea.style.border = "none";
      textarea.style.outline = "none";
      textarea.style.boxShadow = "none";
      textarea.style.background = "transparent";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.notify("Copied to clipboard");
      } catch (e) {
        document.body.removeChild(textarea);
      }
      // this.notify("Copying not supported in this dapp browser");
    } else {
      navigator.clipboard
        .writeText(this.state.contractAddress)
        .then(() => {
          this.notify("Copied to clipboard");
        })
        .catch((err) => {
          this.notify(err);
        });
    }
  };

  navigateToHome = () => {
    this.props.router.navigate("/?refid=" + this.state.userId);
  }

  handleRefLinkCopy = () => {
    if (navigator.clipboard) {
      // this.notify("Copying not supported in this dapp browser");
      var textarea = document.createElement("textarea");
      textarea.textContent =
        "https://elephants.money/?refid=" + this.state.userId;
      textarea.style.position = "fixed";
      textarea.style.width = "2em";
      textarea.style.height = "2em";
      textarea.style.padding = 0;
      textarea.style.border = "none";
      textarea.style.outline = "none";
      textarea.style.boxShadow = "none";
      textarea.style.background = "transparent";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.notify("Copied to clipboard");
      } catch (e) {
        document.body.removeChild(textarea);
      }
    } else {
      navigator.clipboard
        .writeText("https://elephants.money/?refid=" + this.state.userId)
        .then(() => {
          this.notify("Copied to clipboard");
        })
        .catch((err) => {
          this.notify(err);
        });
    }
  };

  handleBuyLevel = async (level) => {
    const wallet = await getWallet();
    if (wallet.isReadOnly) {
      this.notify("Please connect your wallet");
      return;
    }
    const userBrowserAddresses = await wallet.provider.listAccounts();
    if (this.state.userAddress !== userBrowserAddresses[0]) {
      this.notify(
        "You can't Buy for other person's, if its yours then connect your wallet with this ID"
      );
      return;
    }
    try {
      var transactionService = new TransactionService(
        this.state.userId,
        this.state.userAddress
      );
      const buyLevelPromise = transactionService.buyLevel(level);
      await toast.promise(buyLevelPromise, {
        pending: "Transaction in process please wait...",
        success: "Upgrade Completed! 👌",
        error: "Upgrade failed ",
      });
      await this.initializeState(this.state.userAddress);
    } catch (error) {
      alert(error.message);
    }
  };

  getIdClass = (id) => {
    return id == 0 ? "bg-white-100" : "bg-white";
  };
  render() {
    // background-color: #ffeaa7;
    // background-image: linear-gradient(315deg, #ffeaa7 0%, #000000 74%);
    return (
      <div
        style={{ backgroundColor: "#000000" }}
        className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14"
      >
        <div className="
flex
relative
flex-1
py-2
pt-8.5
flex-col
justify-between
w-full
px-2
sm:px-0
sm:pt-7.5
">
          {/* Top Panel, Matrix levels and all activies inside below div */}
          <div className="flex flex-col w-full space-y-10 sm:space-y-5">
            {/* Top panel of Dashboard mobile view inside below div */}

            <div className="col-span-1 grid-right p-5 rounded-md flex flex-col items-center">
                                                
                 <img
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  src="/logo/logo.png"
                  className="light"
                  alt="logo"
                  onClick={this.goHome}
                  
                />
               <h2
                  className="mt-5 mb-3"
                  style={{ fontSize: "30px", fontWeight: "bold" }}
                >
                  ID # {this.state.userId}
                </h2>
                <AiOutlineShareAlt style={{ fontSize: "30px" }} />
                <span className="py-3">Your Wallet </span>
                <div
                  className="border p-4 flex items-center gap-3 rounded-md"
                  style={{
                    borderColor: "rgb(15, 247, 250)",
                    columnGap: "4",
                    borderStyle: "dashed",
                  }}
                >
                <span>
                  {this.state.userAddress
                   ? this.state.userAddress.slice(0, 5) +
                     "..." +
                    this.state.userAddress.slice(-5)
    : ""}
</span>
                  <AiFillCopy onClick={this.handleCopy}
                  className="cursor-pointer text-2xl hover:scale-110 transition" />
                </div>   
              </div>

              <div className="w-full overflow-x-auto flex justify-center">

  {/* SCALE WRAPPER */}
  <div
    style={{
      width: "1100px",
      transform: `scale(${this.state.matrixScale})`,
      transformOrigin: "top left"

    }}
  >
    <div className="main-card flex justify-center">

      {this.state.idsWithLevels.map((ids, index) => {
        const isActive = index + 1 <= this.state.levelBought;

        return (
          <Slot
            key={index}
            ids={ids}
            index={index}
            levelPrices={levelPrices}
            userId={this.state.userId}
            isAuthorized={this.state.isAuthorized}
            reinvestCounts={this.state.reinvestCounts}
            onSlotClick={this.props.onSlotClick}
            onAutoRunClick={this.props.onAutoRunClick}
            onBuyLevel={this.handleBuyLevel}
            isActive={isActive}
          />
        );
      })}

    </div>
  </div>
</div>

                <br></br>

                <div
  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 w-full"  // Start Income section
  style={{ gap: "10px" }}
>
      <div
  className="
    border rounded-md
    p-6
    flex flex-col
    items-center
    justify-center
    text-center
    h-full
  "
  style={{
    borderColor: "rgb(15, 247, 250)",
    background: "rgba(112, 100, 0, 0.25)",
  }}
>
  <span className="font-bold text-base mb-2">
    Total Income
  </span>

  <span className="text-xl font-semibold font-mono">
    {this.state.userTotalIncome}
  </span>
</div>

<div
  className="
    border rounded-md
    p-6
    flex flex-col
    items-center
    justify-center
    text-center
    h-full
  "
  style={{
    borderColor: "rgb(15, 247, 250)",
    background: "rgba(112, 100, 0, 0.25)",
  }}
>
  <span className="font-bold text-base mb-2">
    Referral Income
  </span>

  <span className="text-xl font-semibold font-mono">
    {this.state.refIncome}
  </span>
</div>

<div
  className="
    border rounded-md
    p-6
    flex flex-col
    items-center
    justify-center
    text-center
    h-full
  "
  style={{
    borderColor: "rgb(15, 247, 250)",
    background: "rgba(112, 100, 0, 0.25)",
  }}
>
  <span className="font-bold text-base mb-2">
    Multi-Payout Income
  </span>

  <span className="text-xl font-semibold font-mono">
    {this.state.multiPayoutEarning}
  </span>
</div>   
{/*Ene of income*/}

            

            <div
              className="  grid 
    grid-cols-1 
    sm:grid-cols-2 
    lg:grid-cols-3 
    gap-4"

              style={{ gap: "10px" }}
            >
              <div className="col-span-2 grid-left">
                <div className="grid grid-cols-2" style={{ gap: "10px" }}>
                  <div
                    className="col-span-1 border p-5 rounded-md"
                    style={{
                      borderColor: "rgb(255, 218, 71)",
                      background: " rgba(112, 100, 0, 0.25)",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "18px",
                        marginBottom: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      Referrer ID
                    </h3>
                    <div className="flex items-center justify-between ">
                      <h2 style={{ fontSize: "18px" }}>{this.state.origRef}</h2>
                      <AiOutlineApartment style={{ fontSize: "50px" }} />
                    </div>
                  </div>
                  <div
                    className="col-span-1 border p-5 rounded-md"
                    style={{
                      borderColor: "rgb(15, 247, 250)",
                      background: " rgba(112, 100, 0, 0.25)",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "18px",
                        marginBottom: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      Amount of Partner
                    </h3>
                    <div className="flex items-center justify-between ">
                      <h2 style={{ fontSize: "18px" }}>{this.state.partners}</h2>
                      <AiOutlineUsergroupAdd style={{ fontSize: "50px" }} />
                    </div>
                  </div>
                </div>

<br></br>


                      <div
              className="rounded-md p-5"
              style={{
                // borderColor: "rgb(255, 218, 71)",
                background: " rgba(112, 100, 0, 0.25)",
              }}
            >
              

              <p style={{ fontSize: "20px" }} className="mb-5">
                Register under this ID
              </p>              
<button
  onClick={this.navigateToHome}
  className="px-4 py-2 rounded-md font-semibold 
             bg-blue-500 border-2 border-green-300 
             text-white hover:bg-blue-600 transition"
>
  Register
</button>
<br></br>
              <span className="block mb-2">Your Refferal Link</span>
              
<div
  className="border p-4 flex items-center rounded-md"
  style={{
    borderColor: "rgb(15, 247, 250)",
    borderStyle: "dashed",
  }}
>
  <span className="text-sm truncate flex-1">
    https://elephants.money/?refid={this.state.userId}
  </span>

  <AiFillCopy
    onClick={this.handleRefLinkCopy}
    className="cursor-pointer text-2xl hover:scale-110 transition"    
  />
</div>                
      </div> 
            </div> 
              </div>         
            </div>

</div> 
{/* <br></br>

<div className="w-full overflow-x-auto flex justify-center">

 <div
    style={{
      width: "1100px",
      transform: `scale(${this.state.matrixScale})`,
      transformOrigin: "top left"

    }}
  >
    <div className="main-card flex justify-center">

      {this.state.idsWithLevels.map((ids, index) => {
        const isActive = index + 1 <= this.state.levelBought;

        return (
          <Slot
            key={index}
            ids={ids}
            index={index}
            levelPrices={levelPrices}
            userId={this.state.userId}
            isAuthorized={this.state.isAuthorized}
            reinvestCounts={this.state.reinvestCounts}
            onSlotClick={this.props.onSlotClick}
            onAutoRunClick={this.props.onAutoRunClick}
            onBuyLevel={this.handleBuyLevel}
            isActive={isActive}
          />
        );
      })}

    </div>
  </div>
</div> */}


          <footer
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            className="flex lg:flex-col items-center mt-auto justify-between lg:justify-start lg:items-start py-10 w-full lg:p-5 lg:pb-9 pb-0 lg:pb-0 z-10"
          >
            <div className="hidden lg:block mb-7.5">
              <div className="flex space-x-5 w-full">
                <a
                  className="w-6 h-6 sm:w-7 sm:h-7 flex justify-center items-center rounded-full bg-white-100 hover:bg-white-300"
                  target="_blank"
                  href="https://t.me/elmoney2026"
                >
                  <svg
                    className="w-3 h-3 sm:w-4 sm:h-4"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      clipRule="evenodd"
                      d="M11.915.776.841 5.168a.4.4 0 0 0 .03.755l2.79.864 1.133 3.503a.4.4 0 0 0 .653.17l1.64-1.523 3.11 2.29a.4.4 0 0 0 .627-.231l2.166-9.294a.8.8 0 0 0-1.075-.926Zm-6.483 6.74-.346 2.072-.8-2.901 7.816-5.1-6.67 5.929Z"
                      fill="#fff"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }
}

export default withWrapper(Dashboard);
